import React from "react";
import {
	faBriefcase,
	faBuildingColumns,
	faLanguage,
	faSchool,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Card from "../common/card";

import { useLanguage } from "../../i18n/LanguageContext";

import "./styles/works.css";

const Works = () => {
	const { messages } = useLanguage();
	const { cardTitle, entries } = messages.works;
	const workIcons = [faSchool, faLanguage, faBriefcase, faBuildingColumns];

	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title={cardTitle}
				body={
					<div className="works-body">
						{entries.map((entry, i) => (
							<div className="work" key={i}>
								<div className="work-icon" aria-hidden="true">
									<FontAwesomeIcon
										icon={workIcons[i] || faBriefcase}
									/>
								</div>
								<div className="work-title">{entry.title}</div>
								<div className="work-subtitle">{entry.subtitle}</div>
								<div className="work-duration">{entry.duration}</div>
							</div>
						))}
					</div>
				}
			/>
		</div>
	);
};

export default Works;
